import { Component } from '@verndale/core';
import { CountUp } from 'countup.js';
import { inView } from 'motion';
import { initBorderAnimation } from '../helpers';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      statsNumber: [
        ...this.el.querySelectorAll('.the-outcome-v2__stats-circle span')
      ]
    };

    this.init();
  }

  addListeners() {}

  init() {
    inView(
      this.dom.statsNumber[0],
      () => {
        this.initStats();
      },
      { amount: 0.6 }
    );
  }

  initStats() {
    const options = {
      duration: 2
    };

    this.dom.statsNumber.forEach(stat => {
      const circle = stat.closest('.the-outcome-v2__stats-circle');
      if (circle.classList.contains('active')) return;
      if (!stat.dataset.number) {
        circle.classList.add('active');
        const circleBorder = circle.querySelector('circle');
        circleBorder.style.animation = 'none';
        circleBorder.classList.add('animate-circle');
        circleBorder.style.strokeDashoffset = 0;
        circleBorder.style.strokeDasharray = 0;

        return;
      }


      const demo = new CountUp(stat, Number(stat.dataset.number), options);
      if (demo.error) {
        return console.error(demo.error);
      }

      circle.classList.add('active');
      initBorderAnimation(stat);
      demo.start();
    });
  }
}

export default Module;
